import { lazy } from "react";
import Loadable from "components/Loadable";

const ChartDemo = Loadable(
  lazy(() => import("features/Demo/components/ChartDemo"))
);
const routes = {
  path: "demo",
  children: [{ path: "", element: <ChartDemo /> }],
};

export default routes;
